import styled from 'styled-components'

const GeocoderContainer = styled.div`
  position: relative;
  width: 60%;

  .mapboxgl-ctrl-geocoder {
    width: 100%;
    max-width: none;
    height: 56px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    border: 1px solid rgba(26, 25, 25, 0.2);
    box-shadow: none;

    font-size: 18px;
    line-height: 24px;

    &:focus-within {
      border: 1px solid rgba(26, 25, 25, 0.4);
      box-shadow: 0 2px 6px 0 rgba(26, 25, 25, 0.2);
    }

    &:hover {
      border: 1px solid rgba(55, 111, 139, 0.6);
    }
  }

  .mapboxgl-ctrl-geocoder--input {
    padding: 0 45px;
  }

  .mapboxgl-ctrl-geocoder--icon-search {
    top: auto;
    left: 15px !important;
  }

  .mapboxgl-ctrl-geocoder--button,
  .mapboxgl-ctrl-geocoder--icon-loading {
    top: 16px !important;
    right: 15px !important;
  }
`

export { GeocoderContainer }
